import { Tooltip, Typography } from '@mui/material';
import { isEmpty, replace } from 'lodash';
import React from 'react';
import { AlertCircle } from 'react-feather';
import CompanyInfoNoData from 'src/features/CompanyDetail/Common/CompanyInfoNoData';
import { TypeContributeCompany } from 'src/features/CompanyDetail/Common/config';

// Component
import DataTable from 'src/features/CompanyDetail/Common/DataTable';
import { EmptyText } from 'src/utils/constants/config';
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';
import { useCompanyContribute } from 'src/zustand/useCompanyContribute';

export default function IndustryClassifications({
  dataCompany,
  // isShowLoading,
}: {
  dataCompany: ICompanyDetail;
  // isShowLoading: boolean;
}) {
  const { handleOpenContribute } = useCompanyContribute((state) => state);
  const listData = getArrayDefault(dataCompany?.industries).map((industry, index) => ({
    key: `${industry?.id} + ${index}`,
    title: industry?.name ? replace(industry.name || '', 'SSIC', 'SIC') : EmptyText, // Fix issue: CU-86eqrycrr
    value: industry?.description ? replace(industry.description || '', 'SSIC', 'SIC') : EmptyText, // Fix issue: CU-86eqrycrr
  }));

  // if (isEmpty(listData) && !isShowLoading) {
  if (isEmpty(listData)) {
    return (
      <CompanyInfoNoData
        title="Data Limitations"
        content={
          <>
            There is limited data available for this company. Our data is sourced from official government records and
            public sources. Please consider{' '}
            <Typography
              variant="body1"
              color="secondary.main"
              component="span"
              onClick={() => handleOpenContribute(TypeContributeCompany.ClaimCompanyProfile)}
              sx={{ cursor: 'pointer' }}
            >
              contributing your own data{' '}
            </Typography>
            to make this profile more complete.
          </>
        }
      />
    );
  }

  return (
    <React.Fragment>
      <Typography variant="h5" align="left">
        Industry Classifications{' '}
        {dataCompany.is_chatgpt_industry && (
          <Tooltip
            title="This below categories are AI generated and may not reflect the official company
          records"
          >
            <AlertCircle size={18} />
          </Tooltip>
        )}
      </Typography>

      <DataTable listData={listData} />
    </React.Fragment>
  );
}
